import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import api, { apiPut } from 'api';
import { toast } from 'react-toastify';
import './collector.scss';
import { LanguageType, SpeakerType, StationType } from 'types';


function CollectorForm({
    fileId,
    incFileIndex
} : {
    fileId:number,
    incFileIndex: Function
}) {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data: any) => {
        setLoading(true);
        console.log(data);
        console.log(data.Sentence);
        api.sentence.create(fileId, data)
        .then(
            incFileIndex()
        )
    };
    const dispatch = useDispatch();

    const [sentence, setSentence] = useState("");
    const [entities, setEntities] = useState("");
    const [loading, setLoading] = useState(false);
    const [languages, setLanguages] = useState<LanguageType[]>([]);
    const [speakers, setSpeakers] = useState<SpeakerType[]>([]);
        
    useEffect(() => {
        getLanguages();
        getSpeakers();
    }, [dispatch]);
    
    const getLanguages = useCallback(async () => {
        await api.broadcast.getLanguages()
        .then(data => {
            // console.log(data);
            setLanguages(data);
        })
    }, [dispatch]);

    const getSpeakers = useCallback(async () => {
        await api.speaker.getAll()
        .then(data => {
            // console.log(data);
            setSpeakers(data);
        })
    }, [dispatch]);

    // function handleSubmit() {
    //     if (!sentence) { toast.warning("Sentence cannot be empty"); return; }
    //     // if (!entities) { toast.warning("Entities cannot be empty"); return; }
            
    //     setLoading(true);
    //     api.sentence.create(fileId, sentence)
    //     .then(data => {
    //         console.log(data);
    //         setLoading(false);
    //     })
    //     .catch(err => {
    //         toast.error(err.toString());
    //         setLoading(false);
    //     })
    // }

    return (
        <div id="collectorForm">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='formBlock'>
                    <label htmlFor="Language"> Language </label>
                    <select {...register("LanguageId", { required: true })}>
                        {/* <option value="947">947</option> */}
                        {languages.map((item: LanguageType, i: number) => {
                            return (
                            <option key={i} value={item.Id} label={item.Name} />
                            )
                        })}
                    </select>
                </div>                
                <div className='formBlock'>
                    <label htmlFor="Speaker"> Speaker </label>
                    <select {...register("SpeakerId", { required: true })}>
                        {speakers.map((item: SpeakerType, i: number) => {
                            return (
                            <option key={i} value={item.Id} label={item.Description} />
                            )
                        })}
                    </select>
                </div>
                <label htmlFor="sentence">Sentence </label>
                <input id="sentence" type="text" placeholder="Use common sense." {...register("Description", { required: true })} onChange={(e: any) => setSentence(e.target.value)} />
                {/* <input id="sentence" type="text" placeholder="Use common sense." onChange={(e: any) => setSentence(e.target.value)} readOnly onFocus={(e) => e.target.removeAttribute("readonly")} onKeyUp={(e) => e.key === "Enter" ? handleSubmit() : null} /> */}
                {/* <label htmlFor="entities">Entities </label>
                <input id="entities" type="text" placeholder="ABSA; Standard Bank;" onChange={(e: any) => setEntities(e.target.value)} readOnly onFocus={(e) => e.target.removeAttribute("readonly")} onKeyUp={(e) => e.key === "Enter" ? handleSubmit() : null} /> */}
                <button type="submit"> SUBMIT </button>
            </form>
            
        </div>        
    )
}

export default CollectorForm;